__turbopack_context__.v({
  "AdminBannerText": "gNEDVG_AdminBannerText",
  "BannerText": "gNEDVG_BannerText",
  "DateTime": "gNEDVG_DateTime",
  "DetailsContainer": "gNEDVG_DetailsContainer",
  "EventAgeRestriction": "gNEDVG_EventAgeRestriction",
  "EventDetailsHeaderContent": "gNEDVG_EventDetailsHeaderContent",
  "EventHeader": "gNEDVG_EventHeader",
  "EventSubhead": "gNEDVG_EventSubhead",
  "EventSubtitle": "gNEDVG_EventSubtitle",
  "EventSupportingAct": "gNEDVG_EventSupportingAct",
  "ImageContainer": "gNEDVG_ImageContainer",
  "Separator": "gNEDVG_Separator",
  "SwoopBottom": "gNEDVG_SwoopBottom",
  "SwoopTop": "gNEDVG_SwoopTop",
  "Title": "gNEDVG_Title",
  "blink": "gNEDVG_blink",
});
